'use client';

import Link from 'next/link';
import type { CTABlock } from '@impact/types';

interface Props {
  block: CTABlock;
  editing?: boolean;
}

/**
 * Diagonal split variant: angled clip-path divides the block into two halves
 */
export function CTADiagonal({ block, editing }: Props) {
  const { title, subtitle, buttonText, buttonUrl } = block.data;

  return (
    <div className="my-12 relative overflow-hidden rounded-2xl bg-zinc-900 text-white min-h-[220px]">
      {/* Left solid half */}
      <div
        className="absolute inset-0 bg-primary"
        style={{ clipPath: 'polygon(0 0, 58% 0, 42% 100%, 0 100%)' }}
      />
      {/* Content */}
      <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 px-10 py-12">
        <div className="flex-1 min-w-0">
          <h2
            className="text-2xl md:text-3xl font-bold text-primary-foreground"
            {...(editing ? { 'data-editable': 'data.title' } : {})}
          >
            {title}
          </h2>
          {subtitle ? (
            <p
              className="mt-2 text-base text-primary-foreground/80"
              {...(editing ? { 'data-editable': 'data.subtitle' } : {})}
            >
              {subtitle}
            </p>
          ) : null}
        </div>
        <div className="flex-shrink-0">
          <Link
            href={editing ? '#' : buttonUrl}
            onClick={editing ? (e) => e.preventDefault() : undefined}
            className="inline-block px-8 py-3 rounded-lg font-semibold bg-white text-zinc-900 hover:bg-white/90 transition-colors"
          >
            <span {...(editing ? { 'data-editable': 'data.buttonText' } : {})}>{buttonText}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
